import { render, staticRenderFns } from "./PMStructureCreateTemplateModal.vue?vue&type=template&id=8882547a&"
import script from "./PMStructureCreateTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./PMStructureCreateTemplateModal.vue?vue&type=script&lang=ts&"
import style0 from "./PMStructureCreateTemplateModal.vue?vue&type=style&index=0&id=8882547a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports